import React from 'react';
import style from './style.scss';
import {DateTime} from 'components/UI/DateTime';
import {UploadImage} from 'components/UI/Image';
import {Link} from 'react-router-dom';

class HighlightNeedOfferItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {}
  }

  render() {
    return (
      <div className="highlight-need-offer-item">
        <p className='item-description'>
          <a className='item-link' href=''>
            {this.props.item.user && this.props.item.user.businesses
              ? (this.props.item.user.businesses.length > 0
                ? <strong>[Doanh nghiệp]
                  </strong>
                : null)
              : (null)
}
            {this.props.item.content}
          </a>
        </p>
        <div className='content-justify'>
          <div className='item-left-content'>
            <div className='item-wrap-image'>
              {this.props.item.user
                ? (<UploadImage transform="crop" className='item-image' width="25" height="25" type="USER" image={this.props.item.user.businesses && this.props.item.user.businesses.length > 0
                  ? this.props.item.user.businesses[0].logo
                  : this.props.item.user.avatar}/>)
                : (null)
}
            </div>
            <p className='item-user-name'>
              {this.props.item.user
                ? (this.props.item.user.businesses && this.props.item.user.businesses.length > 0
                  ? (
                    <Link to={`business/${this.props.item.user.businesses[0].id}`}>{this.props.item.user.businesses[0].name}</Link>

                  )
                  : (this.props.item.user.fullname))
                : (null)
}
            </p>
          </div>
          <div className='item-right-content'>
            <i className='vtd-calendar'/>
            <DateTime dateTime={this.props.item.updatedAt}/>
          </div>
        </div>
      </div>
    );
  }
}

HighlightNeedOfferItem.defaultProps = {
  businessAvatar: require('assets/images/header/business-default-avt.png'),
  avatar: require('assets/images/header/user-default-avt.png')
};

export default HighlightNeedOfferItem;



// WEBPACK FOOTER //
// ./components/home/sub-view/HighlightNeedOffer/HighlightNeedOfferItem.jsx